import React from 'react';
import { HeroContent } from './HeroContent';
import { HeroQuotePanel } from './HeroQuotePanel';
import { TrustBar } from './TrustBar';
import { AccidentsHappen } from './AccidentsHappen';
import { Services } from './Services';
import { Reviews } from './Reviews';
import { RepairOrReplace } from './RepairOrReplace';
import { SideDoorRear } from './SideDoorRear';
import { TruckGlass } from './TruckGlass';
import { ADAS } from './ADAS';
import { Insurance } from './Insurance';
import { Process } from './Process';
import { Locations } from './Locations';
import { AutoGlassFAQ } from '../../components/AutoGlassFAQ/AutoGlassFAQ';
import { FinalCTA } from './FinalCTA';
import { StickyMobileCTA } from './StickyMobileCTA';
export function AutoGlassRepair() {
  return <main className="w-full min-h-screen bg-white font-sans text-navy-900 pb-20 md:pb-0" data-id="element-165">
      <section className="relative bg-slate-50 pt-8 pb-12 lg:pt-10 lg:pb-14 overflow-hidden" data-id="element-166">
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-167">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-red-50/60 blur-3xl" data-id="element-168" />
          <div className="absolute bottom-[10%] -left-[10%] w-[50%] h-[50%] rounded-full bg-slate-200/50 blur-3xl" data-id="element-169" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start" data-id="element-170">
          <HeroContent data-id="element-171" />
          <HeroQuotePanel data-id="element-172" />
        </div>
      </section>
      <TrustBar data-id="element-173" />
      <AccidentsHappen data-id="element-174" />
      <Services data-id="element-175" />
      <Reviews data-id="element-176" />
      <RepairOrReplace data-id="element-177" />
      <SideDoorRear data-id="element-178" />
      <TruckGlass data-id="element-179" />
      <ADAS data-id="element-180" />
      <Insurance data-id="element-181" />
      <Process data-id="element-182" />
      <Locations data-id="element-183" />
      <AutoGlassFAQ data-id="element-184" />
      <FinalCTA data-id="element-185" />
      <StickyMobileCTA data-id="element-186" />
    </main>;
}